// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Tabs_buttons__1I2hb","button":"Tabs_button__aG3kv","active":"Tabs_active__3s-pl"};